import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export type AnnouncementDialogData = {
  title: string;
  details: string;
};

@Component({
  template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content>
      <p>{{ data.details }}</p>
    </div>
    <div mat-dialog-actions>
      <button mat-button mat-dialog-close>Close</button>
    </div>
  `,
})
export class AnnouncementDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: AnnouncementDialogData) {}
}
